(() => {
  let busy = false;
  let attempts = 0;
  let timer;
  let revision = 0;
  let nextAttempt = 0;
  const scopes = () => document.querySelector('cart-items')
    ? [document.querySelector('cart-items'), document.querySelector('#main-cart-footer')].filter(Boolean)
    : [document.querySelector('cart-drawer')].filter(Boolean);
  const find = selector => scopes().some(scope => scope.querySelector(selector));
  const incomplete = () => find('[data-milagro-incomplete-item]');
  const blocked = () => find('[data-milagro-incomplete-item],[data-milagro-invalid-size]');
  const syncButtons = () => {
    const invalid = blocked();
    scopes().forEach(scope => scope.querySelectorAll('[name="checkout"]').forEach(button => {
      if (invalid) {
        button.disabled = true;
        button.setAttribute('data-milagro-checkout-blocked', '');
      } else if (button.hasAttribute('data-milagro-checkout-blocked')) {
        const termsScope = button.closest('#main-cart-footer,cart-drawer');
        const terms = termsScope?.querySelector('terms-checkbox input[type="checkbox"]');
        const empty = scopes().some(node => node.classList.contains('is-empty'));
        button.disabled = empty || Boolean(terms && !terms.checked);
        button.removeAttribute('data-milagro-checkout-blocked');
      }
    }));
  };
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(check, Math.max(150, nextAttempt - Date.now()));
  };
  async function check() {
    syncButtons();
    if (!blocked()) { attempts = 0; nextAttempt = 0; return; }
    if (busy || !incomplete() || attempts >= 6) return;
    busy = true;
    attempts++;
    const startedRevision = revision;
    try {
      const main = document.querySelector('cart-items');
      const drawer = document.querySelector('cart-drawer');
      if (main?.updating) return;
      const sections = [...new Set(main ? main.getSectionsToRender().map(s => s.section) : ['cart-drawer'])];
      const root = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(root + 'cart.js', {cache:'no-store', signal:AbortSignal.timeout(5000)});
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      const sectionsResponse = await fetch(root + 'cart?sections=' + encodeURIComponent(sections.join(',')) + '&_milagro=' + Date.now(),
        {cache:'no-store', signal:AbortSignal.timeout(5000)});
      if (!sectionsResponse.ok) return;
      const rendered = await sectionsResponse.json();
      if (revision !== startedRevision || main?.updating || sections.some(id => typeof rendered[id] !== 'string')) return;
      const state = {...cart,sections:rendered};
      if (main) main.renderContents(state);
      else if (drawer) drawer.renderContents(state, true, false);
      document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart:state}}));
    } catch (error) {
      console.warn('Cart details could not be refreshed', error);
    } finally {
      busy = false;
      syncButtons();
      if (incomplete() && attempts < 6) {
        nextAttempt = Date.now() + [500, 1000, 1500, 2500, 4000][attempts - 1];
        schedule();
      }
    }
  }
  document.addEventListener('click', event => {
    if (blocked() && event.target.closest('[name="checkout"],a[href$="/checkout"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      schedule();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (blocked() && (event.submitter?.name === 'checkout' || event.target.matches('form[action$="/cart"]'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      schedule();
    }
  }, true);
  document.addEventListener('change', event => {
    if (event.target.closest('cart-items,cart-drawer,#main-cart-footer')) { revision++; schedule(); }
  });
  new MutationObserver(records => {
    if (!records.some(record => scopes().some(scope => scope === record.target || scope.contains(record.target)))) return;
    revision++;
    schedule();
  }).observe(document.body, {childList:true,subtree:true});
  window.addEventListener('cart:terms:change', schedule);
  window.addEventListener('pageshow', () => { attempts = 0; nextAttempt = 0; schedule(); });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) { attempts = 0; nextAttempt = 0; schedule(); }
  });
  schedule();
})();

